import React from "react";
import { waLink } from "../lib/api";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { metaTrack } from "../analytics/metaPixel";

export const WhatsAppFloat = () => (
  <a
    href={waLink("Namaste! I'm browsing R V Ilkal Sarees and have a question.")}
    onClick={() => metaTrack("Contact", { content_name: "WhatsApp chat" })}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-black/20 hover:scale-105 transition-transform"
  >
    <WhatsAppIcon className="w-6 h-6" />
  </a>
);
